import { FilterValueListService, FilterValue } from '../filter/types';
import { Injectable } from '@angular/core';
import { RewardStatus } from '@app/core/types/reward';
import { RewardStatusTranslationPipe } from '@app/shared/pipes/reward-status-translation.pipe';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class RewardStatusValueListService implements FilterValueListService {
  private rewardStatusTranslationPipe = new RewardStatusTranslationPipe();

  constructor(private translate: TranslateService) {}

  getFilterValues$(): FilterValue[] {
    return Object.values(RewardStatus).map(value => {
      return {
        value: value,
        displayText: this.translate.instant(this.rewardStatusTranslationPipe.transform(value))
      };
    });
  }
}